// src/components/TimePicker.js
import React from "react";
// import DatePicker from 'react-datepicker';
// import 'react-datepicker/dist/react-datepicker.css';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";

const CustomTimePicker = ({ selectedTime, onTimeChange }) => {
  const [value, setValue] = React.useState(dayjs(selectedTime));

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        value={value}
        onChange={(newValue) => {
          setValue(newValue);
          onTimeChange(newValue);
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomTimePicker;
